import { render, staticRenderFns } from "./examination-list.vue?vue&type=template&id=336f2c0f&scoped=true&"
import script from "./examination-list.vue?vue&type=script&lang=js&"
export * from "./examination-list.vue?vue&type=script&lang=js&"
import style0 from "./examination-list.vue?vue&type=style&index=0&id=336f2c0f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336f2c0f",
  null
  
)

export default component.exports